import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  IcFileAlt, IcPlus, IcPdf, IcAt, IcExcel,
  IcReceipt, IcCalc, IcPercent, IcCheckCircle,
  IcEdit, IcInfo, IcSave,
} from "../../../Icons";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../../pdfUtils";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";

function ListadoGastosGeneral() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_GASTOS_GENERAL = process.env.REACT_APP_URL_GASTOS_GENERAL;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

// Obtener el primer día del mes en curso
let inicio = new Date(date.getFullYear(), date.getMonth(), 1);
let inicio2 = moment(inicio).format("YYYY-MM-DD");

  const [gastos, setGastos] = useState([]);
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(inicio2);
  const [selectedFechaFin, setSelectedFechaFin] = useState(hoy);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState();
  const [fecha, setFecha] = useState();
  const [subtotal, setSubtotal] = useState();
  const [iva, setIva] = useState();
  const [descripcion, setDescripcion] = useState("");
  const [totalEdit, setTotalEdit] = useState();
  const [aplicado,           setAplicado]           = useState("");
  const [selectedConcepto,   setSelectedConcepto]   = useState("");
  const [refreshCount,       setRefreshCount]       = useState(0);
  const [modalCreate,        setModalCreate]        = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);
  const [conceptosGastos,    setConceptosGastos]    = useState([]);
  const [gFecha,             setGFecha]             = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [gConcepto,          setGConcepto]          = useState("");
  const [gDescripcion,       setGDescripcion]       = useState("");
  const [gSubtotal,          setGSubtotal]          = useState("");
  const [gIva,               setGIva]               = useState(0);
  const [gTotal,             setGTotal]             = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
      axios
        .get(
          `${URL_GASTOS_GENERAL}GastosDiarioGeneral/${selectedFechaInicio}/${selectedFechaFin}`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((response) => {
          let allGastos = response.data;
          let arrayTabla = allGastos
            .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
            .map((a) => {
              return {
                _id: a._id,
                fecha: a.fecha,
                descripcion: a.descripcion,
                subtotal: a.subtotal,
                iva: a.iva,
                total: a.total,
                concepto: a.conceptosGastos[0].name,
                aplicado: a.aplicado
              };
            })
            .filter(function (el) {
              return el != null;
            });

          let dataFinal = Object.values(arrayTabla);
          setComments(dataFinal);
          setGastos(dataFinal);
        })
        .catch((err) => {
        });

  }, [user, selectedFechaInicio, selectedFechaFin, refreshCount]); // eslint-disable-line

  // Fetch conceptos for create modal
  useMemo(() => {
    axios.get(process.env.REACT_APP_URL_CONCEPTOS_GASTOS, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    }).then((r) => setConceptosGastos(r.data || [])).catch(() => {});
  }, []); // eslint-disable-line

  function saveGasto() {
    if (!gFecha || !gConcepto || !gDescripcion || !gSubtotal) {
      return Swal.fire({ icon: "warning", title: "Completa todos los campos requeridos" });
    }
    axios.post(URL_GASTOS_GENERAL, {
      fecha: gFecha, subtotal: Number(gSubtotal), iva: Number(gIva),
      total: Number(gTotal), descripcion: gDescripcion,
      conceptosGastos: gConcepto, aplicado: "No",
    }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then(() => {
        setGFecha(moment(new Date()).format("YYYY-MM-DD"));
        setGConcepto(""); setGDescripcion(""); setGSubtotal(""); setGIva(0); setGTotal(0);
        setModalCreate(false);
        setRefreshCount((p) => p + 1);
        Swal.fire({ icon: "success", title: "Gasto registrado", timer: 1500, showConfirmButton: false });
      })
      .catch(() => Swal.fire({ icon: "error", title: "Error al guardar" }));
  }

  let total = 0;
  let totalTabla = 0;

  function PDFTabla() {
    total = 0;
    const data = gastos.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) 
      ) {
        total = total + c.total;
        const importePDF = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(c.total);
        return [c.fecha, c.concepto, c.descripcion, importePDF];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Detalle de Gastos", `${selectedFechaInicio} — ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      head: [["Fecha", "Concepto", "Descripcion", "Importe"]],
      body: dataPDFLimpia,
      startY,
      foot: [
        ["", "", "Total", new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(total)],
      ],
      showFoot: "lastPage",
    });
    pdfFooter(doc);
    doc.save("DetalleGastos.pdf");
  }

  function excel() {
    const dataExcel = gastos.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) 
      ) {
        return {
          Fecha: c.fecha,
          Concepto: c.concepto,
          Descripcion: c.descripcion,
          Importe: c.total,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `DetalleGastos-${selectedFechaInicio}-${selectedFechaFin}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: `DetalleGastos`,
        sheetFilter: ["Fecha", "Concepto", "Descripcion", "Importe"],
        sheetHeader: ["Fecha", "Concepto", "Descripcion", "Importe"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    total = 0;
    const data = gastos.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) 
      ) {
        total = total + c.total;
        const importePDF = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(c.total);
        return [c.fecha, c.concepto, c.descripcion, importePDF];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Detalle de Gastos", `${selectedFechaInicio} — ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      head: [["Fecha", "Concepto", "Descripcion", "Importe"]],
      body: dataPDFLimpia,
      startY,
      foot: [
        ["", "", "Total", new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(total)],
      ],
      showFoot: "lastPage",
    });
    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Lista de Gastos",
          email: mailTo,
          fileName: "ListaGastos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras la lista de Gastos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
      });
  }

  function jalaInfo(id, fecha, subtotal, iva, total, descripcion) {
    setIdEdit(id);
    setFecha(fecha);
    setSubtotal(subtotal);
    setIva(iva);
    setTotalEdit(total);
    setDescripcion(descripcion);
    toggleEdit();
  }

  const calculaEdit = (val) => {
    setSubtotal(val);
    setTotalEdit(parseFloat(val || 0) + parseFloat(iva || 0));
  };

  const calculaIVAEdit = (val) => {
    setIva(val);
    setTotalEdit(parseFloat(subtotal || 0) + parseFloat(val || 0));
  };

  const editGasto = (event) => {
    const URL_GASTOS_GENERAL_EDIT = `${process.env.REACT_APP_URL_GASTOS_GENERAL}/${idEdit}`;
    event.preventDefault();
    axios
      .all([
        axios.patch(
          URL_GASTOS_GENERAL_EDIT,
          {
            fecha,
            subtotal,
            iva,
            total: totalEdit,
            descripcion,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Edit Gasto",
            detalle: `Fecha: ${fecha} / Descripcion: ${descripcion} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
      });
  };

  const headers = [
    { name: "Fecha",      field: "fecha",      sortable: true  },
    { name: "Concepto",   field: "concepto",   sortable: true  },
    { name: "Descripcion",field: "descripcion",sortable: true  },
    { name: "Importe",    field: "total",      sortable: false },
    { name: "Aplicado",   field: "aplicado",   sortable: false },
    { name: "Acciones",   field: "acciones",   sortable: false },
  ];

  const summaryStats = useMemo(() => {
    const fmtI         = (v) => "$" + new Intl.NumberFormat("en-US").format(Math.round(v || 0));
    const totalGastado = comments.reduce((s, g) => s + (Number(g.total) || 0), 0);
    const totalIva     = comments.reduce((s, g) => s + (Number(g.iva)   || 0), 0);
    const aplicados    = comments.filter((g) => g.aplicado === "Si").length;
    return {
      count:        comments.length,
      totalGastado: fmtI(totalGastado),
      totalIva:     fmtI(totalIva),
      promedio:     fmtI(comments.length > 0 ? totalGastado / comments.length : 0),
      aplicados,
    };
  }, [comments]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
          comment.descripcion.toLowerCase().includes(search.toLowerCase()) 
      );
    }

    if (aplicado) {
      computedComments = computedComments.filter((e) => e.aplicado.includes(aplicado));
    }

    if (selectedConcepto) {
      computedComments = computedComments.filter((e) => e.concepto === selectedConcepto);
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    aplicado,
    selectedConcepto,
  ]);

  function aplicar(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se va a aplicar!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, aplicar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_GASTOS_GENERAL}/${id}`,
            {
              aplicado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se aplico",
              showConfirmButton: false,
              timer: 2000,
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
          });
      }
    });
  }

  return (
    <>
      <Header />
      {user.menu_gastos ? (
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcFileAlt style={{ marginRight: 8, color: "#f59e0b" }} />
                Gastos
              </h3>
              <p className="page-subtitle">Registro de gastos generales</p>
            </div>
            <div className="page-actions">
              <Button size="sm" color="success" onClick={toggleCreate}>
                <IcPlus style={{ marginRight: 6 }} />
                Nuevo Gasto
              </Button>
              <ButtonGroup>
                <Button size="sm" color="danger" onClick={PDFTabla}>PDF <IcPdf /></Button>
                <Button size="sm" color="info" onClick={toggleMail}>eMail <IcAt /></Button>
                <Button size="sm" color="primary" onClick={excel}>Excel <IcExcel /></Button>
              </ButtonGroup>
            </div>
          </div>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Lista de Gastos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          {/* ── Summary cards ──────────────────────────────────────────── */}
          <div className="row mb-3 mt-1">
            {[
              { label: "Total gastado",   value: summaryStats.totalGastado, sub: `${summaryStats.count} gastos en el período`, icon: IcReceipt,      color: "#ef4444", bg: "#fff1f2" },
              { label: "Promedio / gasto",value: summaryStats.promedio,     sub: "Importe medio por registro",                 icon: IcCalc,         color: "#8b5cf6", bg: "#f5f3ff" },
              { label: "Total IVA",       value: summaryStats.totalIva,     sub: "IVA acumulado",                              icon: IcPercent,      color: "#f59e0b", bg: "#fffbeb" },
              { label: "Aplicados",       value: summaryStats.aplicados,        sub: "Gastos marcados como aplicados",         icon: IcCheckCircle,  color: "#3b82f6", bg: "#eff6ff" },
            ].map((card, i) => (
              <div key={i} className="col-6 col-md-3 mb-2">
                <div style={{ background: "#fff", borderRadius: 14, padding: "16px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", borderTop: `3px solid ${card.color}`, display: "flex", alignItems: "center", gap: 14, height: "100%" }}>
                  <div style={{ width: 46, height: 46, borderRadius: 12, background: card.bg, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <card.icon style={{ color: card.color, fontSize: "1.2rem" }} />
                  </div>
                  <div>
                    <div style={{ fontSize: "1.1rem", fontWeight: 800, color: "#0f172a", lineHeight: 1 }}>{card.value}</div>
                    <div style={{ fontSize: "0.67rem", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>{card.label}</div>
                    <div style={{ fontSize: "0.7rem", color: card.color, fontWeight: 600, marginTop: 2 }}>{card.sub}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="filter-bar">
            <div>
              <Label>Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </div>
            <div>
              <Label>Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </div>
            <div>
              <Label>Aplicado</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 110 }}
                value={aplicado}
                onChange={(e) => {
                  setAplicado(e.target.value);
                }}
              >
                <option value="">Todos</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </div>
            <div>
              <Label>Concepto</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 160 }}
                value={selectedConcepto}
                onChange={(e) => { setSelectedConcepto(e.target.value); setCurrentPage(1); }}
              >
                <option value="">Todos</option>
                {[...new Set(comments.map((g) => g.concepto).filter(Boolean))].sort().map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </Input>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-6 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Table
            size="sm"
            striped
            borderless
            className="table-responsive-xl table-dark-header"
          >
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />

            <tbody>
              {commentsData.map((c) => {
                totalTabla = totalTabla + c.total;
                return (
                  <tr>
                    <td>{c.fecha}</td>
                    <td>{c.concepto}</td>
                    <td>{c.descripcion}</td>
                    <td>
                      {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(c.total)}
                    </td>
                    <td>{c.aplicado}</td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <Button
                          color="info"
                          size="sm"
                          title="Editar gasto"
                          onClick={() => jalaInfo(c._id, c.fecha, c.subtotal, c.iva, c.total, c.descripcion)}
                        >
                          <IcEdit />
                        </Button>
                        {c.aplicado === "No" && (
                          <Button color="primary" size="sm" title="Aplicar" onClick={() => aplicar(c._id)}>
                            <IcCheckCircle />
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(totalTabla)}
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4>
                <IcFileAlt style={{ marginRight: 8, color: "#f59e0b" }} />
                Editar Gasto
              </h4>
            </ModalHeader>
            <ModalBody>
              {/* Sección 1: Información */}
              <div className="form-section">
                <div className="form-section-header">
                  <IcInfo />
                  <span className="form-section-title">Información del Gasto</span>
                </div>
                <div className="form-section-body">
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Fecha</Label>
                        <Input
                          type="date"
                          value={fecha}
                          required
                          onChange={(e) => setFecha(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={8}>
                      <FormGroup>
                        <Label>Descripción</Label>
                        <Input
                          type="text"
                          placeholder="Descripción del gasto"
                          value={descripcion}
                          required
                          onChange={(e) => setDescripcion(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
              {/* Sección 2: Importes */}
              <div className="form-section">
                <div className="form-section-header dark">
                  <IcCalc />
                  <span className="form-section-title">Importes</span>
                </div>
                <div className="form-section-body">
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Subtotal</Label>
                        <Input
                          type="number"
                          min="0"
                          step="any"
                          value={subtotal}
                          required
                          onChange={(e) => calculaEdit(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>IVA</Label>
                        <Input
                          type="number"
                          min="0"
                          step="any"
                          value={iva}
                          required
                          onChange={(e) => calculaIVAEdit(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Total</Label>
                        <Input
                          type="number"
                          value={totalEdit}
                          disabled
                          style={{ background: "#f0fdf4", fontWeight: 700, color: "#15803d" }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={editGasto}>
                <IcSave style={{ marginRight: 6 }} />
                Guardar Cambios
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      ) : undefined}
      {/* ── Modal Nuevo Gasto ────────────────────────────────────────── */}
      <Modal size="md" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <IcReceipt style={{ marginRight: 8, color: "#f59e0b" }} />
          Nuevo Gasto
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>Fecha <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="date" value={gFecha} onChange={(e) => setGFecha(e.target.value)} required />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Concepto <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input type="select" value={gConcepto} onChange={(e) => setGConcepto(e.target.value)} required
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="">Selecciona</option>
                  {conceptosGastos.sort((a, b) => a.name > b.name ? 1 : -1).map((c) => (
                    <option key={c._id} value={c._id}>{c.name}</option>
                  ))}
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-12">
              <FormGroup>
                <Label>Descripción <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="text" value={gDescripcion} onChange={(e) => setGDescripcion(e.target.value)} required />
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup>
                <Label>Subtotal <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="number" min="0" step="any" value={gSubtotal}
                  onChange={(e) => { setGSubtotal(e.target.value); setGTotal(Number(e.target.value) + Number(gIva)); }} required />
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup>
                <Label>IVA</Label>
                <Input bsSize="sm" type="number" min="0" step="any" value={gIva}
                  onChange={(e) => { setGIva(e.target.value); setGTotal(Number(gSubtotal) + Number(e.target.value)); }} />
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup>
                <Label>Total</Label>
                <Input bsSize="sm" type="number" value={gTotal} disabled style={{ background: "#f8fafc", fontWeight: 700 }} />
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveGasto}>
            <IcSave style={{ marginRight: 6 }} /> Guardar
          </Button>
          <Button color="secondary" onClick={toggleCreate}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoGastosGeneral;
